<template>
  <v-dialog
    v-model="dialog"
    max-width="550"
    content-class="sc-modal sc-modal--md"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        class="admin-add-btn"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small class="mr-1">mdi-plus</v-icon>
        Adicionar câmera
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-video-plus-outline</v-icon>
        <div>
          <span class="sc-modal__title">Nova câmera</span>
          <span class="sc-modal__subtitle">Adicione uma nova câmera à praça selecionada</span>
        </div>
      </div>

      <!-- Body -->
      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">NOME</label>
          <v-text-field
            v-model="nome"
            solo flat dense hide-details="auto"
            background-color="surface_tertiary"
            placeholder="Nome da câmera"
          />
        </div>

        <div class="sc-modal__field">
          <label class="sc-modal__field-label">DESCRIÇÃO</label>
          <v-text-field
            v-model="descricao"
            solo flat dense hide-details="auto"
            background-color="surface_tertiary"
            placeholder="Descrição da câmera"
          />
        </div>

        <div class="sc-modal__field">
          <label class="sc-modal__field-label">ENDEREÇO</label>
          <v-text-field
            v-model="endereco"
            solo flat dense hide-details="auto"
            background-color="surface_tertiary"
            placeholder="Endereço da câmera"
          />
        </div>

        <div class="field-row">
          <div class="sc-modal__field field--grow">
            <label class="sc-modal__field-label">
              <v-icon x-small color="text_secondary" class="mr-1">mdi-access-point</v-icon>
              URL RTSP
            </label>
            <v-text-field
              v-model="source_url"
              solo flat dense hide-details="auto"
              background-color="surface_tertiary"
              placeholder="rtsp://..."
            />
          </div>
          <div class="sc-modal__field field--geo">
            <label class="sc-modal__field-label">
              <v-icon x-small color="text_secondary" class="mr-1">mdi-map-marker-outline</v-icon>
              GEOLOCALIZAÇÃO
            </label>
            <v-text-field
              v-model="geolocation"
              solo flat dense hide-details="auto"
              background-color="surface_tertiary"
              placeholder="lat, lng"
            />
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text class="modal-btn-cancel" @click="dialog = false">Cancelar</v-btn>
        <v-btn color="primary" class="modal-btn-confirm" :loading="loading" @click.prevent="handleInsertCamera">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions } from "vuex";

export default {
  props: {
    codPraca: Number,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      nome: "",
      descricao: "",
      endereco: "",
      coordenadas: {},
      source_url: "",
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.nome = "";
        this.descricao = "";
        this.endereco = "";
        this.coordenadas = {};
        this.source_url = "";
      }
    },
  },
  methods: {
    ...mapActions({
      getCamerasByPraca: "cameras/getCamerasByPraca",
    }),
    async handleInsertCamera() {
      if ((this.nome || "").trim() === "") {
        this.$toast.warning("Informe o nome da câmera.");
        return;
      }
      this.loading = true;
      try {
        await apiClient.post("/cameras", {
          nome: this.nome,
          descricao: this.descricao,
          endereco: this.endereco,
          coordenadas: this.coordenadas,
          rtsp_source: this.source_url,
          cod_praca: this.codPraca,
        });
        await this.getCamerasByPraca({
          page: this.$store.state.cameras.camerasPraca.page,
          size: this.$store.state.cameras.camerasPraca.size,
          cod_praca: this.codPraca,
          filtro_texto: "",
        });
        this.$toast.success("Câmera inserida com sucesso!");
        this.dialog = false;
      } catch (error) {
        const msg = error.response?.data?.error || "Erro ao inserir a câmera.";
        this.$toast.error(msg);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    geolocation: {
      get() {
        if (!this.coordenadas.latitude && !this.coordenadas.longitude) {
          return "";
        }
        return `${this.coordenadas.latitude || ""}, ${this.coordenadas.longitude || ""}`;
      },
      set(newValue) {
        const parts = (newValue || "").split(",");
        this.coordenadas.latitude = (parts[0] || "").trim();
        this.coordenadas.longitude = (parts[1] || "").trim();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.field-row {
  display: flex;
  gap: 16px;
}

.field--grow {
  flex: 1;
}

.field--geo {
  width: 200px;
  flex-shrink: 0;
}
</style>
